import React from "react";
import "./cmistyle.css"; // We will define the CSS separately for cleaner styling
import cmilogo from "../../assets/used-images/cmipng.png"
const CMILogo = () => {
  return (
    <div className="cmi-container ">
      <div className="cmi-header">
        <div className="cmi-logo">معهد الادارة المعتمدة CMI</div>
        <img src={cmilogo} alt="CMI Logo" className="cmi-image" />
      </div>
      <div className="cmi-content">
      <h2 className="services-header after:w-20 after:-bottom-2 mb-4">
      معهد الإدارة المعتمدة CMI                        </h2>
        <ul>
            <li>يكرّس معهد الإدارة المعتمدة (CMI) جهوده لتعزيز التميز في الإدارة والقيادة. تأسس المعهد في عام 1947 كالمعهد البريطاني للإدارة بهدف المساعدة في إعادة بناء الصناعة البريطانية بعد الحرب العالمية الثانية. واليوم، يظل هدف المعهد هو زيادة عدد ومستوى المديرين المؤهلين مهنيًا، مستفيدًا من ميثاقه الملكي الفريد الذي منح له في عام 2002، مما يخوله منح لقب "مدير معتمد" المرموق.</li>
            <li>يدعم معهد المديرين المعتمدين أكثر من 180,000 عضو من خلال مجموعة متنوعة من البرامج التي تشمل المؤهلات العملية، والفعاليات، وفرص التواصل المصممة لتعزيز الآفاق المهنية وربط المهنيين عبر الصناعات. وبتركيز قوي على القيادة الفكرية والبحث، يقدم المعهد رؤى قيمة ويمثل مجتمعه في مناقشات السياسات، بهدف ضمان إدارة وقيادة أفضل للمنظمات.</li>
            <li>يلتزم المعهد بالشمولية والممارسة الأخلاقية والتحسين المستمر، ملتزمًا بقيمه التي تتمثل في الاحترافية، والتقدم، والشغف، والعملية. ومن خلال تعزيز الشراكات والحفاظ على حضور قوي سواء في المملكة المتحدة أو على الصعيد العالمي، يسعى المعهد ليكون السلطة الرائدة في ممارسة الإدارة.</li>

        </ul>
        
      </div>
    </div>
  );
};

export default CMILogo;
